import { render, staticRenderFns } from "./SbButton.vue?vue&type=template&id=41bd87e8"
import script from "./SbButton.vue?vue&type=script&lang=js"
export * from "./SbButton.vue?vue&type=script&lang=js"
import style0 from "./SbButton.vue?vue&type=style&index=0&id=41bd87e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports